(function () {
  var EU =
    'AT,BE,BG,CY,CZ,DE,DK,EE,ES,FI,GR,HR,HU,IE,IT,LT,LU,LV,MT,NL,PL,PT,RO,SE,SI,SK'.split(',');

  function countryFromCookie() {
    var m = document.cookie.match(/(?:^|;\s*)localization=([A-Z]{2})/i);
    return m ? m[1].toUpperCase() : null;
  }

  function zoneForCountry(cc) {
    if (!cc) return null;
    if (cc === 'FR') return 'fr';
    if (EU.indexOf(cc) !== -1) return 'eu';
    return 'intl';
  }

  function zoneText(el, zone) {
    if (zone === 'fr') return el.getAttribute('data-zone-fr');
    if (zone === 'eu') return el.getAttribute('data-zone-eu');
    return el.getAttribute('data-zone-intl');
  }

  function formatNotice(text) {
    if (!text) return '';
    var parts = text.split(' · ');
    if (parts.length < 2) return text;
    return '<strong>' + parts[0] + '</strong> · ' + parts.slice(1).join(' · ');
  }

  function zoneClass(zone) {
    if (zone === 'fr') return 'market-shipping-notice--france';
    if (zone === 'eu') return 'market-shipping-notice--eu';
    return 'market-shipping-notice--intl';
  }

  function applyMarketShipping() {
    var zone = zoneForCountry(countryFromCookie());
    if (!zone) return;

    document.querySelectorAll('[data-market-shipping-notice]').forEach(function (el) {
      var text = zoneText(el, zone);
      if (!text) return;
      el.innerHTML = formatNotice(text);
      el.classList.remove('market-shipping-notice--france', 'market-shipping-notice--eu', 'market-shipping-notice--intl');
      el.classList.add(zoneClass(zone));
    });

    document.querySelectorAll('[data-market-announcement]').forEach(function (el) {
      var html =
        zone === 'fr'
          ? el.getAttribute('data-text-fr')
          : zone === 'eu'
            ? el.getAttribute('data-text-eu')
            : el.getAttribute('data-text-intl');
      if (html) el.innerHTML = html;
    });

    document.querySelectorAll('[data-market-zone-block]').forEach(function (el) {
      var zones = (el.getAttribute('data-visible-zones') || '').split(',');
      el.hidden = zones.indexOf(zone) === -1;
    });

    document.querySelectorAll('[data-faq-shipping-answer]').forEach(function (el) {
      var text = zoneText(el, zone);
      if (text) el.textContent = text;
    });
  }

  document.addEventListener('DOMContentLoaded', applyMarketShipping);
  document.addEventListener('shopify:section:load', applyMarketShipping);
  document.addEventListener('change', function (e) {
    if (e.target && (e.target.name === 'country_code' || e.target.name === 'locale_code')) {
      setTimeout(applyMarketShipping, 400);
    }
  });
})();
